export const regex_cpf = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
export const regex_cnpj = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
export const regex_cep = /^\d{5}-\d{3}$/;
export const regex_remove_all_non_digits = /[^\d]+/g;
